class ProductCards {
    constructor(element) {
        element.addEventListener("click", this.onClick.bind(this));    
        this.element = element;
        this.target = document.querySelector(`${element.dataset.target}`);
        this.init();
    }
  
    init() {
        var numberOfProductCards = document.getElementsByClassName("productcardsblock__grid-item").length;
        var productGrid = document.querySelectorAll(".productcardsblock__grid");
        console.log(numberOfProductCards);

        if (numberOfProductCards == 3) {
            // console.log(productGrid);
            productGrid.forEach((grid) => 
            grid.classList.add("three-column")
            );   
        } else if (numberOfProductCards == 2) {
            productGrid.forEach((grid) => 
            grid.classList.add("two-column")
            );
        } else if (numberOfProductCards == 1) {
            productGrid.forEach((grid) => 
            grid.classList.add("one-column")
            );
        }
    }

    onClick() {
        console.log("pls");
    }
}
   
export default ProductCards;